import script from "./Graph.vue?vue&type=script&setup=true&lang=js"
export * from "./Graph.vue?vue&type=script&setup=true&lang=js"

import "./Graph.vue?vue&type=style&index=0&id=ca1fc7dc&lang=scss&scoped=true"

import exportComponent from "/Users/cricle/Documents/monetware/code/web/knowledgeGraph-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca1fc7dc"]])

export default __exports__